import PropTypes from 'prop-types';
import cn from 'classnames';

export default function LdsTable({
  id,
  caption,
  children,
  striped = false,
  flat = false,
  layoutClass = '',
  captionSide = 'top',
  captionClass = 'h3',
  captionStyle = {},
  captionAttributes,
  tableClass,
  tableAttributes,
  className,
  ...rest
}) {
  const TableCaption = () => {
    return (
      <p
        className={cn(
          'lds-table-caption',
          captionClass
        )}
        style={captionStyle}
        id={`${id}-caption`}
        {...captionAttributes}
      >
        {caption}
      </p>
    );
  };

  return (
    <>
      {caption && captionSide === 'top' && <TableCaption />}
      <div
        className={cn(
          'lds-table-wrapper',
          className
        )}
        tabIndex="0"
        role="group"
        aria-labelledby={`${id}-caption`}
        {...rest}
      >
        <table
          id={id}
          role="table"
          className={cn(
            'lds-table',
            layoutClass,
            {
              striped,
              flat,
            },
            tableClass
          )}
          {...tableAttributes}
        >
          {children}
        </table>
      </div>
      {caption && captionSide === 'bottom' && <TableCaption />}
    </>
  );
}

LdsTable.propTypes = {
  id: PropTypes.string.isRequired,
  captionSide: PropTypes.oneOf(['top', 'bottom']),
  captionClass: PropTypes.string,
  layoutClass: PropTypes.oneOf(['layout-auto', 'layout-fixed']),
  flat: PropTypes.bool,
  striped: PropTypes.bool,
};
